import React from "react";
import {
  Avatar,
  Box,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { ExitToApp, Person } from "@mui/icons-material";
import theme from "../../theme";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "../../store";
import { logout } from "../../slices/auth";

interface Props {
  handleClose: () => void;
}

const Profile: React.FC<Props> = (props) => {
  const { handleClose } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { awsUser: loggedInUser, dbUser } = useSelector((store) => store.auth);

  const menuItems = [
    {
      label: "Account",
      icon: <Person />,
      function: () => navigate("/account"),
    },
    {
      label: "Logout",
      icon: <ExitToApp />,
      function: () => {
        dispatch(logout());
      },
    },
  ];

  return (
    <Box width={250} display="flex" role="presentation" onClick={handleClose}>
      <List sx={{ width: "100%" }}>
        <ListItem disablePadding>
          <ListItemText
            primary={
              <Typography
                color="primary"
                variant="h4"
                justifySelf="center"
                paddingX={1}
                sx={{ overflowWrap: "anywhere" }}
              >
                {!!dbUser
                  ? `${dbUser?.firstName} ${dbUser?.lastName}`
                  : `${loggedInUser?.signInDetails?.loginId}`}
              </Typography>
            }
          />
        </ListItem>
        <Divider sx={{ margin: 1 }} />
        {menuItems.map((item) => (
          <Box key={item.label}>
            <ListItem disablePadding>
              <ListItemButton
                onClick={item.function}
                sx={{
                  "&:hover, &:focus": {
                    "& svg:first-of-type": {
                      transition: "0.5s",
                      transform: "rotate(-180deg)",
                    },
                  },
                }}
              >
                <ListItemIcon sx={{ paddingX: 2 }}>
                  <Avatar
                    sx={{
                      backgroundColor: theme.palette.primary.main,
                      width: "35px",
                      height: "35px",
                      color: "#fff",
                    }}
                  >
                    <IconButton color="inherit">{item.icon}</IconButton>
                  </Avatar>
                </ListItemIcon>
                <ListItemText
                  primary={item.label}
                  primaryTypographyProps={{
                    fontSize: 16,
                    fontWeight: "light",
                    color: "primary",
                  }}
                />
              </ListItemButton>
            </ListItem>
          </Box>
        ))}
      </List>
    </Box>
  );
};

export default Profile;
